import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import QuanLyThuChiHopDongApi from "service/quanLyThuChiHopDongApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { pushNotification } from "utils/notifications";

export const ModalChiTietPhiHangKy = ({ show, onHide, item }) => {
  const [dataChiTiet, setDataChiTiet] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    QuanLyThuChiHopDongApi.chiTietPhiHangKyPhieu(item.ThuChiID)
      .then((response) => {
        if (!active) return;
        setDataChiTiet(response.data || []);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setLoading(false);
        pushNotification(
          "Không lấy được chi tiết các loại phí",
          "error",
          "TOP_CENTER",
          2000,
        );
      });
    return () => {
      active = false;
    };
  }, [item.ThuChiID]);

  // Số tiền từ API có tối đa 2 chữ số lẻ; làm tròn để tránh sai số cộng số thực
  const tong =
    Math.round(dataChiTiet.reduce((s, x) => s + x.SoTien, 0) * 100) / 100;

  const listItem = () => {
    if (loading) {
      return (
        <tr>
          <td colSpan="3" className="text-center">
            Đang tải...
          </td>
        </tr>
      );
    }
    if (dataChiTiet.length === 0) {
      return (
        <tr>
          <td colSpan="3" className="text-center">
            Không có dữ liệu
          </td>
        </tr>
      );
    }
    return (
      <>
        {dataChiTiet.map((x, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{x.TenPhi}</td>
            <td className="text-right">{formatNumber(x.SoTien)}</td>
          </tr>
        ))}
        <tr>
          <td colSpan="2" className="text-right">
            <b>Tổng</b>
          </td>
          <td className="text-right">
            <b>{formatNumber(tong)}</b>
          </td>
        </tr>
      </>
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="modal-new-size modal-new-size border-modalNew"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title">
          <span className="btn-icon-right">
            <i className="fas fa-funnel-dollar"></i>
          </span>{" "}
          Chi tiết các loại phí
        </h4>
        <button
          type="button"
          className="close-popup-new"
          aria-label="Close"
          onClick={onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="form-body">
          <div className="card">
            <div className="card-header border-info">
              <h3 className="card-title lead info">
                {item.Code} - {item.TypeName} ngày {getDate(item.Time)}
              </h3>
            </div>
            <div className="card-content">
              <div className="card-body">
                <div className="table-responsive table-2">
                  <table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th>STT</th>
                        <th>Tên phí</th>
                        <th className="text-right">Số tiền</th>
                      </tr>
                    </thead>
                    <tbody>{listItem()}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <a
          className="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
